import './App.css';
import 'swiper/swiper-bundle.css';
import 'swiper/css/navigation';
import 'slick-carousel/slick/slick.css';  
import 'slick-carousel/slick/slick-theme.css';
import 'react-toastify/dist/ReactToastify.css';
import "react-medium-image-zoom/dist/styles.css";
import 'react-loading-skeleton/dist/skeleton.css';
import "react-lazy-load-image-component/src/effects/blur.css";
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/mousewheel';
import "swiper/css/pagination";
import React, { useEffect } from 'react';
import { syncBrandColorFromServer } from './utils/theme';
import Base from './pages/Base';
import Checkout from './pages/Checkout';
import ProductPage from './pages/ProductPage';
import ProductDetails from './pages/ProductDetails';
import Payment from './pages/Payment';
import About from './pages/About';

import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './components/user/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

import Login from './components/user/Login';
import Register from './components/user/Register';
import Profile from './components/user/Profile';
import Wishlist from './pages/Wishlist';
import Cart from './pages/Cart';
import ThankYou from './pages/ThankYou';
import NotFound from './pages/NotFound';
import ScrollToTop from './components/ScrollToTop';
import SearchPage from './pages/SearchPage';
// mobile
import Planters from './pages/mobile/Planters';
import Container from './pages/mobile/Container';
import Categories from './pages/mobile/Categories';
import TermsCondition from './pages/TermsCondition';
import Privacy from './pages/Privacy';
// import Contact from './pages/Contact';
import ReturnPolicy from './pages/ReturnPolicy';
import FridgeBottle from './pages/mobile/FridgeBottle';
import Tasla from './pages/mobile/Tasla';
import Mug from './pages/mobile/Mug';
import Return from './pages/Return';
import OrderDetails from './components/user/OrderDetails';
import ResetPassword from './components/user/ResetPassword';
import SearchableTabs from './pages/SearchableTabs';
import AnswerPage from './pages/AnswerPage';
import Bucket from './pages/mobile/Bucket';
import VarifyEmail from './components/user/VarifyEmail';
import ReviewSubmission from './components/user/ReviewSubmission';


function App() {
    useEffect(() => {
        syncBrandColorFromServer();
    }, []);

    return (
        <AuthProvider>
        <ScrollToTop />
          <Routes>
            <Route path="/search" element={<SearchPage />} />

            
            <Route path="/login" element={<Login />} />
            <Route path="/email-verification" element={<VarifyEmail />} />
            <Route path="/register" element={<Register />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/review/:token" element={<ReviewSubmission />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/wishlist" element={<ProtectedRoute><Wishlist /></ProtectedRoute>} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/u/profile" element={<Profile />} />
            <Route path="/myaccount" element={<ProtectedRoute><Profile section="Overview" /></ProtectedRoute>} />
            <Route path="/myaccount/orders" element={<ProtectedRoute><Profile section="My Orders" /></ProtectedRoute>} />
            <Route path="/myaccount/order/:orderId" element={<OrderDetails />} />
            <Route path="/myaccount/return/:orderId" element={<Return />} />
            {/* <Route path="/return" element={<Return />} /> */}

            {/* <Route path="/myaccount/order/:orderId" element={<ProtectedRoute><Profile section="Order Details" /></ProtectedRoute>} /> */}
            <Route path="/myaccount/payments" element={<ProtectedRoute><Profile section="My Payments" /></ProtectedRoute>} />
            {/* <Route path="/myaccount/wallet" element={<ProtectedRoute><Profile section="My Wallet" /></ProtectedRoute>} /> */}
            <Route path="/myaccount/addresses" element={<ProtectedRoute><Profile section="My Addresses" /></ProtectedRoute>} />
            <Route path="/myaccount/profile" element={<ProtectedRoute><Profile section="My Profile" /></ProtectedRoute>} />
            <Route path="/logout" element={<Profile section="Logout"/>} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<Base />} />
            <Route path="/products" element={<ProductPage showAll={true} />} />
            <Route path="/:categorySlug" element={<ProductPage />} />
            {/* <Route path="/products" element={<ProductPage />} /> */}
            <Route path="/p/:slug" element={<ProductDetails />} />
            <Route path="/payment" element={<Payment/>} />
            <Route path="/thank-you" element={<ThankYou/>} />

            {/* inner pages */}
            <Route path="/about-us" element={<About />} />
            <Route path="/terms-and-conditions" element={<TermsCondition />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/contact-us" element={<SearchableTabs />} />
            <Route path="/contact-us/page" element={<AnswerPage />} />
            <Route path="/return-policy" element={<ReturnPolicy />} />
            

            {/* mobile */}
            <Route path='/categories' element={<Categories />} />
            <Route path="/campaign/planters" element={<Planters />} />
            <Route path="/campaign/container" element={<Container />} />           
            <Route path='/campaign/fridge-bottle' element={<FridgeBottle />} />
            <Route path='/campaign/bucket' element={<Bucket />} />
            <Route path='/campaign/tasla' element={<Tasla />} />
            <Route path='/campaign/mug' element={<Mug />} />
            {/* Catch-all for invalid /campaign/* routes */}
            <Route path="/campaign/*" element={<Navigate to="/404" replace />} />
            <Route path="/myaccount/*" element={<Navigate to="/404" replace />} />
            
            {/* Catch-all route for undefined pages */}
            <Route path="/404" element={<NotFound />} />
          </Routes>
        </AuthProvider>
  );
  
}

export default App;
